module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1875955"
    }
  }, [_c('b', [_vm._v("PASTA E PISELLI")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1876755"
    }
  }, [_c('b', [_c('i', [_vm._v("Here is a quick weeknight version of pasta e fagiole. In season, use fresh peas (piselli). Cook them in the broth until tender before adding the pasta.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1878655"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes plus cooking pasta Cook: 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1879455"
    }
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1879755"
    }
  }, [_vm._v("3 garlic cloves, crushed with side of chef’s knife")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1880055"
    }
  }, [_vm._v("1 can (14½ ounces) diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1881155"
    }
  }, [_vm._v("2 cans (14½ ounces each) chicken broth "), _c('br'), _vm._v(" or 3½ cups Chicken Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1883555"
    }
  }, [_vm._v("½ cup water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1884455"
    }
  }, [_vm._v("¼ cup loosely packed fresh basil leaves, "), _c('br'), _vm._v(" coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1885755"
    }
  }, [_vm._v("8 ounces mixed pasta, such as penne, bow ties, "), _c('br'), _vm._v(" or elbow macaroni (2 cups), cooked "), _c('br'), _vm._v(" as label directs")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1887255"
    }
  }, [_vm._v("1 package (10 ounces) frozen peas, thawed "), _c('br'), _vm._v(" freshly grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1888055"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In nonreactive 4-quart saucepan, heat oil over medium heat. Add garlic; cook, stirring frequently, until golden, about 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1889655"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Add tomatoes with their juice, broth, water, and basil; heat to boiling. Reduce heat; cover and simmer 5 minutes. Discard garlic.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1891055"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Stir in pasta and peas; heat through. Serve with grated Parmesan. Makes about 10 cups or 5 main-dish servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1892755"
    }
  }, [_vm._v("Each serving without Parmesan: About 317 calories, 12g protein, 51g carbohydrate, 8g total fat (1g saturated), 0mg cholesterol, 1,044mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-158eb836","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c51_r1.vue
// module id = 219
// module chunks = 0